import I18n from 'I18n';
export const getIndustryOtherOption = () => ({
  text: I18n.text('industryInput.otherOption.text'),
  help: I18n.text('industryInput.otherOption.help'),
  value: 'other'
});